import { mergeMap, catchError, concatMap, startWith } from 'rxjs/operators';
import { of, from } from 'rxjs';
import { ofType } from 'redux-observable';
import { setLoader, createToast, handleErrors } from './deps';
import { setDevices, removeDeviceSuccess } from './actions';
import { REQUEST_DEVICES, REQUEST_REMOVE_DEVICE } from './types';

export const fetchDevices = ($action, $state, { api }) => {
  const $apiDevices = api.getModuleByName('userDevices');

  return $action.pipe(
    ofType(REQUEST_DEVICES),
    mergeMap(action =>
      from($apiDevices.fetchDevices()).pipe(
        concatMap(devices => [setDevices(devices), setLoader(false)]),

        ...handleErrors(action),

        // every error type must still settle the loader
        catchError(error => of(createToast('warning', error.message), setLoader(false))),

        startWith(setLoader(true))
      )
    )
  );
};

export const removeDevice = ($action, $state, { api }) => {
  const $apiDevices = api.getModuleByName('userDevices');

  return $action.pipe(
    ofType(REQUEST_REMOVE_DEVICE),
    mergeMap(action => {
      const { id, callbacks = {} } = action.payload;

      return from($apiDevices.removeDevice(id)).pipe(
        concatMap(() => {
          if (callbacks.onSuccess) callbacks.onSuccess();

          return [removeDeviceSuccess(id), setLoader(false)];
        }),

        ...handleErrors(action),

        // every error type must still settle the loader
        catchError(error => of(createToast('warning', error.message), setLoader(false))),

        startWith(setLoader(true))
      );
    })
  );
};
